
export const hermioneMediaArray = [
  {
    _id: 'hermioneMediaId1',
    userId: 'hermioneUserId',
    email: 'hermione@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-1-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-1-p.png`,
    description: ``,
    captions: [
      `Woke up like this`,
      `#MondaysAmIRight?`,
      `My best blue steel`
    ],
    subcaptions: [
      `Fantasizing about my next perfect OWL`,
      `Thinking about a very interesting new potion ...or about how dumb the person next to me is... or both`,
      `Let's pretend this is naturally how my hair looks`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'hermioneMediaId2',
    userId: 'hermioneUserId',
    email: 'hermione@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-2-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-2-p.png`,
    description: ``,
    captions: [
      `I'm known for`,
      `How history will remember me`,
      `My life behind the scenes`
    ],
    subcaptions: [
      `Fire + robe + wand = perfect moment`,
      `Stopping myself from casting a shut up spell on the guys in the corner`,
      `Let's pretend I'm thinking something profound`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'hermioneMediaId3',
    userId: 'hermioneUserId',
    email: 'hermione@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-3-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-3-p.png`,
    description: ``,
    captions: [
      `Plandid or candid?`,
      `My good side`,
      `Dating me will look like`
    ],
    subcaptions: [
      `I dare you to ask me to make you dinner again`,
      `Tell me my hair looks pretty or else`,
      `Ask me on a date, if you dare`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'hermioneMediaId4',
    userId: 'hermioneUserId',
    email: 'hermione@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-4-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-4-p.png`,
    description: ``,
    captions: [
      `Felt cute might delete later`,
      `I'm known for`,
      `My quarter life crisis looks like`
    ],
    subcaptions: [
      `Emergency: Forgot all my charms`,
      `Overthinking everything, per usual`,
      `Serious, but fantastic`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'hermioneMediaId5',
    userId: 'hermioneUserId',
    email: 'hermione@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-5-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-5-p.png`,
    description: ``,
    captions: [
      `As seen on my Mom's fridge`,
      `My good side`,
      `Dating me will look like`
    ],
    subcaptions: [
      `As seen on *your* mom's fridge`,
      `The dress is pink. That counts as feminine, right?`,
      `OK, fine, I have a girlie side`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'hermioneMediaId6',
    userId: 'hermioneUserId',
    email: 'hermione@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-6-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-6-p.png`,
    description: ``,
    captions: [
      `As seen on my Mom's fridge`,
      `My good side`,
      `Dating me will look like`
    ],
    subcaptions: [
      `As seen on *your* mom's fridge`,
      `The dress is pink. That counts as feminine, right?`,
      `OK, fine, I have a girlie side`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'hermioneMediaId7',
    userId: 'hermioneUserId',
    email: 'hermione@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-7-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-7-p.png`,
    description: ``,
    captions: [
      `My quarter life crisis looks like`,
      `My uniform`,
      `My best blue steel`
    ],
    subcaptions: [
      `Tie? Check. Too consumed by defending the wizarding world against dark magic to appreciate the weather? Check.`,
      `My "I just rode a dragon" face`,
      `Extremely concerned that I may have answered a question incorrectly on my OWL.`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'hermioneMediaId8',
    userId: 'hermioneUserId',
    email: 'hermione@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-8-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-8-p.png`,
    description: ``,
    captions: [
      `Caught in the act`,
      `Me in my blogging days`,
      `I'm known for`
    ],
    subcaptions: [
      `Tell me my hair looks pretty or else`,
      `Clearly I'm not looking for a "protector"`,
      `And the man of the group is...`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'hermioneMediaId9',
    userId: 'hermioneUserId',
    email: 'hermione@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-9-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-9-p.png`,
    description: ``,
    captions: [
      `Felt cute might delete later`,
      `Leave a one-word review for this`,
      `Me during Fashion Week`
    ],
    subcaptions: [
      `Fine, I'll loosen my tie`,
      `Options include 'chic', 'glamorous', and 'fantastic'`,
      `The world is your dragonwalk`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'hermioneMediaId10',
    userId: 'hermioneUserId',
    email: 'hermione@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-10-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-10-p.png`,
    description: ``,
    captions: [
      `My best blue steel`,
      `Leave a one-word review for this`,
      `Me during Fashion Week`
    ],
    subcaptions: [
      `Tell me my hair looks pretty or else`,
      `Options include 'chic', 'glamorous', and 'fantastic'`,
      `The world is your dragonwalk`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'hermioneMediaId11',
    userId: 'hermioneUserId',
    email: 'hermione@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-11-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-11-p.png`,
    description: ``,
    captions: [
      `#MondaysAmIRight?`,
      `My vulnerable side`,
      `Life outtake`
    ],
    subcaptions: [
      `Tell me my hair looks pretty or else`,
      `I dare you to ask another dumb question`,
      `Fine, I'll loosen my tie`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'hermioneMediaId12',
    userId: 'hermioneUserId',
    email: 'hermione@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-12-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-12-p.png`,
    description: ``,
    captions: [
      `My best blue steel`,
      `Leave a one-word review for this`,
      `Me during Fashion Week`
    ],
    subcaptions: [
      `Tell me you like my sweater or else`,
      `Options include 'chic', 'glamorous', and 'fantastic'`,
      `The world is your dragonwalk`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'hermioneMediaId13',
    userId: 'hermioneUserId',
    email: 'hermione@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-13-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-13-p.png`,
    description: ``,
    captions: [
      `Dating me will look like`,
      `My weekends look like`,
      `As seen on my Mom's fridge`
    ],
    subcaptions: [
      `Rare footage of me smiling`,
      `Book in hand? Ok, I'll smile`,
      `When you know 5 points are about to be awarded to Gryffindor`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'hermioneMediaId14',
    userId: 'hermioneUserId',
    email: 'hermione@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-14-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-14-p.png`,
    description: ``,
    captions: [
      `My best blue steel`,
      `Leave a one-word review for this`,
      `Me in the wild`
    ],
    subcaptions: [
      `Tell me my hair looks pretty or else`,
      `Ask me on a date or else`,
      `Just another girl who loves long hikes`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  }
]